import { api } from "./api";
import { toast } from "sonner";

export async function startCheckout(planId) {
  try {
    const origin = window.location.origin;
    const { data } = await api.post("/payments/checkout/session", {
      plan_id: planId,
      origin_url: origin,
    });
    if (data.url) {
      window.location.href = data.url;
    } else {
      toast.error("Could not start checkout. Please try again.");
    }
  } catch (e) {
    toast.error("Checkout is unavailable right now. Please try again later.");
  }
}
